/* eslint-disable react/no-danger */
import './ConversationTemplate.scss';

import React, { FC, useState } from 'react';
import { wrapHBSTemplatesAndReplaceNewLinesWithBRTags } from 'functions/wrapHandleBarsTemplates';
import { PromptTemplate } from 'models/Prompt';
import { PromptFlow } from 'models/PromptFlow';
import { Button, Card, Col, Modal, Row } from 'react-bootstrap';

interface ConversationTemplateProps {
  conversation: PromptTemplate[],
  type: 'Template' | 'Execution'
  parent: PromptFlow,
  onExecute: (promptFlow: PromptFlow) => void;
}

const ConversationTemplate: FC<ConversationTemplateProps> = ({conversation, type, parent, onExecute}) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <span key={`conversation-template-${parent.id}`}>
      <Button variant='secondary' onClick={handleShow}>
        Details
      </Button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Prompt {type}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='settings'>
            <Row>
              <Col>Model: <strong>{parent.model}</strong></Col>
              <Col>Visibility: {parent.visibility}</Col>
            </Row>
          </div>
          <div className='conversation'>
            {conversation.map( (c, idx) => 
              // eslint-disable-next-line react/no-array-index-key
              <Card className='prompt my-2' key={idx}>
                <Card.Body>
                  <Card.Title>Prompt #{idx+1}</Card.Title>
                  <Card.Text>
                    <span dangerouslySetInnerHTML={{ '__html' : wrapHBSTemplatesAndReplaceNewLinesWithBRTags(c.inputTemplate) }} />
                  </Card.Text>
                </Card.Body>
              </Card>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={() => onExecute(parent)}>
            {type === 'Template' ? 'Run' : 'Run again'}
          </Button>
        </Modal.Footer>
      </Modal>
    </span>
  );
}

export default ConversationTemplate;
